import SectionHeading from './SectionHeading'
import FirstIcon from '../../Icons/HomePage/service/new-services/1.svg'
import SecondIcon from '../../Icons/HomePage/service/new-services/2.svg'
import ThirdIcon from '../../Icons/HomePage/service/new-services/3.svg'
import SectionSubText from './SectionSubText'
import WhiteButton from '../Buttons/WhiteButton'
import S1Icon from '../../Icons/realEsatePostcards/s1.svg'
import S2Icon from '../../Icons/realEsatePostcards/s2.svg'
import S3Icon from '../../Icons/realEsatePostcards/s3.svg'
import S4Icon from '../../Icons/realEsatePostcards/s4.svg'
import { useRouter } from 'next/router'

const postcardBenefits = [
    { Icon: S1Icon, text: 'Generate motivated seller leads' },
    { Icon: S2Icon, text: 'Reinforce multi-touch campaigns' },
    { Icon: S3Icon, text: 'Reach absentee and distressed property owners' },
    { Icon: S4Icon, text: 'Build instant credibility in competitive markets' },
]

const WithBenefits = ({ children }) => {
    const router = useRouter()

    return (
        <div
            className="pb-28"
            style={{
                backgroundImage: "url('/assets/homepage/service/bg.svg')",
                backgroundPosition: 'bottom center',
                backgroundRepeat: 'no-repeat',
            }}>
            <ServicesWrapper>
                {children}
                <div className="py-16 mt-14 md:mt-32 mx-4 -mb-48 px-3 sm:px-12 lg:px-24 max-w-7xl my-12 olm-gradient rounded-xl md:rounded-lg md:mx-auto">
                    <div className="flex flex-col lg:flex-row w-full items-center gap-10">
                        <div className="w-full lg:w-6/12 text-center md:text-left mb-8 md:mb-0 flex flex-col justify-around gap-8">
                            <h2 className="text-4xl md:text-5xl font-bold text-white">
                                When designed and delivered correctly,
                                postcards:
                            </h2>
                            <div className="mt-8 w-80 hidden md:block">
                                <WhiteButton
                                    onClick={() => {
                                        router.push('/get-free-samples')
                                    }}>
                                    <span className="text-orange-400">
                                        Get Free Postcard Samples
                                    </span>
                                </WhiteButton>
                            </div>
                        </div>
                        <div className="flex w-full lg:w-6/12 flex-wrap md:flex-row space-x-2 md:space-x-0 items-center justify-center gap-5">
                            {postcardBenefits.map(({ Icon, text }, idx) => (
                                <div
                                    key={idx}
                                    className="flex border-solid border-2 border-white rounded-xl gap-2 items-center p-3 w-full">
                                    <span className="p-2 rounded-5xl bg-white">
                                        <Icon />
                                    </span>
                                    <p className="text-white text-lg">{text}</p>
                                </div>
                            ))}
                        </div>
                        <div className="mt-8 md:hidden mx-auto w-full">
                            <WhiteButton
                                onClick={() => {
                                    router.push('/get-free-samples')
                                }}>
                                <span className="text-orange-400">
                                    Get Free Postcard Samples
                                </span>
                            </WhiteButton>
                        </div>
                    </div>
                </div>
            </ServicesWrapper>
        </div>
    )
}

const ServicesWrapper = ({ children }) => {
    return (
        <div className="py-16 bg-light-yellow-gradient rounded-4xl md:rounded-8xl">
            {children}
        </div>
    )
}

const ServicesCards = ({ heading }) => {
    return (
        <>
            <div className="text-center mb-16 px-4">
                <SectionHeading>{heading}</SectionHeading>
                <SectionSubText size="max-w-3xl">
                    They cut through digital noise, land directly in a
                    homeowner’s hands, and create a tangible touchpoint that
                    drives action. Real estate postcards are one of the most
                    powerful direct-to-seller tools in your arsenal:
                </SectionSubText>
            </div>

            <div className="max-w-7xl mx-auto px-4 flex flex-wrap gap-6 justify-center">
                {services.map((Service, index) => (
                    <div
                        key={index}
                        className="bg-white p-6 rounded-lg border text-center w-full sm:w-[45%] lg:w-[30%]">
                        <div className="mb-8 text-center justify-center flex">
                            <Service.Icon />
                        </div>
                        <h3 className="text-xl font-semibold text-olm-black mb-2">
                            {Service.title}
                        </h3>
                        <p className="text-olm-new-black">
                            {Service.description}
                        </p>
                    </div>
                ))}
            </div>
        </>
    )
}

function OurServices({
    showCoaches = true,
    heading = (
        <span className="olm-gradient-text">
            Why Real Estate Postcards Work
        </span>
    ),
}) {
    return showCoaches ? (
        <WithBenefits>
            <ServicesCards heading={heading} />
        </WithBenefits>
    ) : (
        <ServicesWrapper>
            <ServicesCards heading={heading} />
        </ServicesWrapper>
    )
}

const services = [
    {
        Icon: FirstIcon,
        title: 'Immediate impact',
        description: 'Bold, professional designs that sellers actually notice',
    },
    {
        Icon: SecondIcon,
        title: 'Cost-effective',
        description:
            'Reach thousands of prospects without breaking your budget',
    },
    {
        Icon: ThirdIcon,
        title: 'Proven results',
        description:
            'Investors consistently report higher conversions vs. cold calls or email alone',
    },
]

export default OurServices
